import React from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { MetricsBar } from './components/MetricsBar';
import { PainPoints } from './components/PainPoints';
import { Achievements } from './components/Achievements';
import { BigMistake } from './components/BigMistake';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { ProductPresentation } from './components/ProductPresentation';
import { LimitedOffer } from './components/LimitedOffer';
import { BonusSection } from './components/BonusSection';
import { OfferSummary } from './components/OfferSummary';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { CTABreak } from './components/CTABreak';
export function App() {
  return <div className="min-h-screen flex flex-col font-body" data-id="element-0">
      <StickyAlertBar data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <MetricsBar data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Achievements data-id="element-6" />
        <CTABreak data-id="element-7" />
        <BigMistake data-id="element-8" />
        <UniqueMechanism data-id="element-9" />
        <WhatIsIncluded data-id="element-10" />
        <CTABreak data-id="element-11" />
        <ProductPresentation data-id="element-12" />
        <LimitedOffer data-id="element-13" />
        <BonusSection data-id="element-14" />
        <CTABreak data-id="element-15" />
        <OfferSummary data-id="element-16" />
        <Testimonials data-id="element-17" />
        <CTABreak data-id="element-18" />
        <Guarantee data-id="element-19" />
        <OfferSummary data-id="element-20" />
        <FAQ data-id="element-21" />
        <FinalCTA data-id="element-22" />
      </main>

      <Footer data-id="element-23" />
    </div>;
}